import type { ITicketHomeLoanFees } from './TicketHomeLoanFees.interface';

export default class TicketHomeLoanFees implements ITicketHomeLoanFees {
  valuation: number;
  solicitor: number;
  settlement: number;
  package: number;
  packageMonthly: number;
  rate: number;
  other: number;
  application: number;

  static build = (data: ITicketHomeLoanFees) => new TicketHomeLoanFees(data);
  static blank = () => new TicketHomeLoanFees();

  /**
   * Constructor
   * @param {ITicketHomeLoanFees} data
   */
  constructor(data?: ITicketHomeLoanFees) {
    this.valuation = parseFloat(data?.valuation || 0);
    this.solicitor = parseFloat(data?.solicitor || 0);
    this.settlement = parseFloat(data?.settlement || 0);
    this.package = parseFloat(data?.package || 0);
    this.packageMonthly = parseFloat(data?.packageMonthly || 0);
    this.rate = parseFloat(data?.rate || 0);
    this.other = parseFloat(data?.other || 0);
    this.application = parseFloat(data?.application || 0);
  }
}
